import { UploadedFile } from '@modules/CourseInboxPage/UploadChatFileModal/UploadChatFileModal';
import { CompactUserResponse } from '../account';
import { PageQuery } from '../common';
import { CourseInboxStatus } from './CourseInboxResponse';

export type CourseInboxReplyId = string;

export enum CourseInboxUserType {
  student = 'student',
  instructor = 'instructor',
}

export interface CourseInboxReplyResponse {
  id: CourseInboxReplyId;
  inboxName: string;
  inboxStatus: CourseInboxStatus;
  replyBy: CompactUserResponse;
  type: CourseInboxUserType;
  isRead: boolean;
  body: string;
  files: UploadedFile[];
  createdAt: number;
  updatedAt: number;
}
